import React from 'react';
import { Box, Typography, Button, Modal, CircularProgress } from '@mui/material';
import { tokens, withAlpha } from '../../Common/designTokens';

/**
 * Modal component for order confirmation
 */
const OrderConfirmationModal = ({ 
  isConfirmOpen, 
  isLoading,  
  orderCount, 
  onConfirm, 
  onCancel,
  errorMessage,
  isRebalance = false,
}) => {
  // Common modal style (token based)
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: tokens.colors.bodyBackgroundColor,
    border: `1px solid ${tokens.colors.bodyBorderColor50}`,
    boxShadow: 24,
    p: 4,
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  return (
    <Modal
      open={isConfirmOpen}
      onClose={!isLoading ? onCancel : undefined} // Prevent closing when loading
      aria-labelledby="confirm-order-modal"
    >
      <Box sx={modalStyle}>
        <Typography id="confirm-order-modal-title" variant="h6" component="h2" sx={{ color: tokens.colors.fontColour, mb: 2, textAlign: 'center', fontWeight: 'bold' }}>
          Submit Orders
        </Typography>
        
        {errorMessage ? (
          <Box sx={{
            mb: 3,
            width: '100%',
            backgroundColor: withAlpha(tokens.palette.danger, 0.08),
            border: `1px solid ${withAlpha(tokens.palette.danger, 0.3)}`,
            borderRadius: '8px',
            p: 2,
            textAlign: 'center'
          }}>
            <Typography sx={{ color: tokens.palette.danger }}>
              {errorMessage}
            </Typography>
          </Box>
        ) : (
          <Typography sx={{ color: tokens.colors.fontColour85, mb: 3, textAlign: 'center' }}>
            {isRebalance
              ? `You are about to submit ${orderCount.toLocaleString()} order${orderCount === 1 ? '' : 's'} based on your rebalance inputs. Please confirm to proceed with the submission.`
              : `You are about to submit ${orderCount.toLocaleString()} order${orderCount === 1 ? '' : 's'} based on your previewed selections. Please confirm to proceed with the submission.`}
          </Typography>
        )}
        
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button
            variant="outlined"
            onClick={onCancel}
            disabled={isLoading}
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              
              width: 120,
              borderRadius: '8px',
              
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            disabled={isLoading}
            startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              width:  isLoading ? "155px" : "140px",
              backgroundColor: tokens.palette.primary,
              color: tokens.colors.white,
              borderRadius: '8px',
              '&:hover': { backgroundColor: tokens.palette.primaryA80 },
            }}
          >
            {isLoading ? 'Processing...' : 'Confirm'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default OrderConfirmationModal;
